import { render, staticRenderFns } from "./integralRemindRegionPage.vue?vue&type=template&id=3e54e9e2&scoped=true&"
import script from "./integralRemindRegionPage.vue?vue&type=script&lang=js&"
export * from "./integralRemindRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./integralRemindRegionPage.vue?vue&type=style&index=0&id=3e54e9e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54e9e2",
  null
  
)

export default component.exports